import { render, staticRenderFns } from "./childInfo.vue?vue&type=template&id=943044f8&scoped=true&"
import script from "./childInfo.vue?vue&type=script&lang=js&"
export * from "./childInfo.vue?vue&type=script&lang=js&"
import style0 from "./childInfo.vue?vue&type=style&index=0&id=943044f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "943044f8",
  null
  
)

export default component.exports